module.exports = __webpack_public_path__ + "static/media/blank_screen_100.e21ac0b5.ico";